import { transformBidOrMidPriceFn } from '../../../../bonds';
import { useSecuritiesSecurityTransformApi } from '../api';

export const useSecuritiesSecurityBidOrMidPrice = () => {
  const response = useSecuritiesSecurityTransformApi(transformBidOrMidPriceFn);
  return response;
};
